import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';

import {
  logAnalyticSFCancelOrder,
  setCancelOrderInSF,
  sfCancelOrderModalObserver,
} from 'features/order/substitution-flow/infra';
import { invalidateGetOrderDetailById } from 'shared/hooks';
import appActions from 'redux/actions/app-actions/app.actions';
import { useSFCancelOrderModalLang } from './useSFCancelOrderModalLang';

import { ORDER_DETAIL_MODEL_INIT as ORDER_INIT } from 'shared/domain';

import type { SubstitutionFlowState } from 'shared/domain';

export function useSFCancelOrderModal() {
  const reduxDispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [order, setOrder] = useState(ORDER_INIT);

  const cancelOrderModal = sfCancelOrderModalObserver();

  const lang = useSFCancelOrderModalLang();

  const handleClose = () => {
    setOrder(ORDER_INIT);
    invalidateGetOrderDetailById(order.id);
    setIsOpen(false);
  };

  const handleCancelOrderSuccess = () => {
    logAnalyticSFCancelOrder({
      SFState: order.substitutionFlowState as SubstitutionFlowState,
    });
    handleClose();
  };

  const handleSend = () => {
    setCancelOrderInSF(order)
      .then(isTrue =>
        isTrue
          ? handleCancelOrderSuccess()
          : alert('Order cancellation return "false"'),
      )
      .catch(({ data: dataErr }: any) =>
        reduxDispatch(
          appActions.openSnackBarError(
            dataErr?.error?.message || 'Order cancellation failed',
            'ERROR',
            5_000,
          ),
        ),
      );
  };

  useEffect(() => {
    cancelOrderModal.add(({ detail }) => {
      setOrder(detail);
      setIsOpen(true);
    });
    return () => {
      cancelOrderModal.remove();
    };
  }, []);

  return {
    lang,
    isOpen,
    orderId: order.id,
    handleClose,
    handleSend,
  };
}
